import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const OnboardingBanner = ({ className }: ClassAttributes<HTMLElement> & Props) => (
  <Root
    className={className}
    href="https://help.kaizen-ad.com/ja/collections/2210474"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Label>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FCB100"
            stroke="#E2E6EF"
            strokeWidth="2"
            d="M8.804 25.733L1 18.123V3.313a2 2 0 0 1 3.103-1.667l5.573 3.686a4 4 0 0 0 4.52-.073l4.84-3.43a2 2 0 0 1 3.156 1.632v14.662l-7.803 7.61a4 4 0 0 1-5.585 0z"
          />
          <path
            fill="#2DB182"
            d="M12.012 25.678V6.895L18.4 2.368A2 2 0 0 1 21.556 4v13.418l-8.868 8.647a.405.405 0 0 1-.676-.387z"
          />
        </g>
      </svg>
      <LabelText>はじめての方へ</LabelText>
    </Label>
    <Text color="primary">
      Kaizen Ad での動画制作にあたり、必要なお手続きや作業内容をご案内しております。
      <br />
      制作開始前のご確認をお願いします。
    </Text>
  </Root>
);

const Root = styled('a')(
  gridLayoutContainer({
    columns: ['auto', '1fr'],
    rows: ['auto'],
    areas: [['label', 'text']],
    alignItems: 'center',
  }),
  {
    backgroundColor: '#fff',
    borderRadius: 4,
    padding: SPACING_UNIT,
    textDecoration: 'none',
  },
);

const Label = styled('div')(
  gridLayoutItem('label'),
  flexibleLayoutContainer({ direction: 'row', alignItems: 'center' }),
  {
    height: 44,
    border: '1px solid #fcb100',
    borderRadius: 22,
    marginRight: SPACING_UNIT * 2,
    padding: '4px 12px 4px 16px',
  },
);

const LabelText = styled(Typography)({
  // fontSize: 1,
  fontWeight: 500,
  marginLeft: SPACING_UNIT,
});

const Text = styled(Typography)(gridLayoutItem('text'), {
  [':hover']: {
    textDecoration: 'underline',
  },
});

export default OnboardingBanner;
